import React, { useState } from 'react';

interface CompanyLogoProps {
  name: string;
  domain?: string;
  className?: string;
}

function CompanyLogo({ name, domain, className = '' }: CompanyLogoProps) {
  const [failed, setFailed] = useState(false);
  const initial = name.charAt(0).toUpperCase();

  if (!domain || failed) {
    return (
      <div
        className={`w-10 h-10 rounded-lg border border-line bg-canvas-muted flex items-center justify-center text-sm font-semibold text-ink-muted flex-shrink-0 ${className}`}
        aria-hidden
      >
        {initial}
      </div>
    );
  }

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${domain}&sz=64`}
      alt=""
      className={`w-10 h-10 rounded-lg border border-line bg-canvas-muted p-1.5 object-contain grayscale opacity-80 flex-shrink-0 ${className}`}
      onError={() => setFailed(true)}
      loading="lazy"
    />
  );
}

export default CompanyLogo;
